import { render } from "./ModalMfr.vue?vue&type=template&id=0ec138d3"
import script from "./ModalMfr.vue?vue&type=script&lang=js"
export * from "./ModalMfr.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__